"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffPrimitiveArray = void 0;
const diffPrimitiveArray = (initialArray, newArray) => [
    newArray.filter((x) => !initialArray.includes(x)),
    initialArray.filter((x) => !newArray.includes(x)),
];
exports.diffPrimitiveArray = diffPrimitiveArray;
//# sourceMappingURL=diff-primitive-array.js.map